export enum OrderView {
    TABLE = "table",
    BOARD = "board",
  }
  